<div class="form-control-container">
  @if (label()) {
  <label class="input-label">{{ label() }}</label>
  }
  <div
    class="options"
    role="radiogroup"
    [attr.aria-label]="label() || null"
    [attr.aria-disabled]="locked() || null"
    [class.disabled]="locked()"
    [class.full-width]="fullWidth()"
    (keydown.arrowleft)="move($event, -1)"
    (keydown.arrowup)="move($event, -1)"
    (keydown.arrowright)="move($event, 1)"
    (keydown.arrowdown)="move($event, 1)"
  >
    @for (option of options(); track option.value) {
    <button
      type="button"
      role="radio"
      class="option"
      [class.selected]="isSelected(option)"
      [attr.aria-checked]="isSelected(option)"
      [attr.tabindex]="isTabStop(option) ? 0 : -1"
      [disabled]="locked() || !!option.disabled"
      (click)="select(option)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    >
      {{ option.label }}
    </button>
    }
  </div>
</div>
